import {UserType} from '@esgi/core/authentication';

export const entityName = 'Specialists Groups';

export const UserTypeOptions = {
	ISD: {id: UserType.ISD, name: 'District'},
	ISS: {id: UserType.ISS, name: 'School'},
	PA: {id: UserType.PA, name: 'Pre-Assess'},
};
